import { useCallback } from 'react';
import { EndPoints } from 'src/config';
import { useFetcher } from 'src/hooks/useFetcher';

type ResponseServer = {
  success: boolean;
  requestId: string;
};

type Payload = {
  token: string;
  customerExperienceFeedbackNote: string;
  customerExperienceFeedbackRatingDriver: string;
  customerExperienceFeedbackRatingService: string;
};

export const useSubmitClientDeliveryRating = () => {
  const { data, fetcher, isLoading, error } = useFetcher<ResponseServer | null>(null);

  const submitClientDeliveryRating = useCallback(
    ({
      token,
      customerExperienceFeedbackNote,
      customerExperienceFeedbackRatingDriver,
      customerExperienceFeedbackRatingService,
    }: Payload) => {
      fetcher(EndPoints.clientDeliveryRating, {
        requiredToken: false,
        body: {
          token,
          customerExperienceFeedbackNote,
          customerExperienceFeedbackRatingDriver,
          customerExperienceFeedbackRatingService,
        },
      });
    },
    [fetcher],
  );

  return {
    submitClientDeliveryRating,
    isLoading,
    error,
    data,
  };
};
